import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';

import { loadUser } from 'redux-oidc';
import userManager from './utils/userManager';

import createRootReducer from './reducers';

export const history = createBrowserHistory();

const middleware = [routerMiddleware(history), promise(), thunk];

const composeEnchancers = composeWithDevTools({ trace: true, traceLimit: 25 });

const store = createStore(
  createRootReducer(history),
  composeEnchancers(applyMiddleware(...middleware))
);
loadUser(store, userManager);

export default store;
